<div class="modal-header">
  <h3>Produktionsvorlagenschritt editieren - {{ data.template.template_name }} - {{ this.data.step.text }}</h3>
</div>

<form class="form-horizontal" [formGroup]="editForm">
  <div class="modal-body">

    <div class="form-group">
      <label for="template-expression" class="col-sm-2 control-label">Bedingung</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" id="template-expression" formControlName="expression"
          [ngClass]="{red_alert: errors['obj.expression']}">

        <div>&nbsp;</div>

        @if (errors['obj.expression']) {
          <span class="red_alert">{{ errors['obj.expression'][0].msg }}</span>
        }
      </div>

    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-success pull-right" (click)="edit()"
      [disabled]="editForm.pristine || !editForm.valid">
      Speichern
    </button>
  </div>
</form>
